/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { IOneToOneTutorRate } from '.';
import { APIDataProvider, ApiPaths, TApiResponse } from '../../../api';

export type TGetTutorRatesForAStudent = {
  tutorId: string;
  studentId: string;
  curriculum: string;
  grade: string;
  courseId?: string;
  includeResourceResourceFee?: boolean;
};

const apiDataProvider = new APIDataProvider();

export const getOneToOneTutorRates = createAsyncThunk(
  '/user/one-to-one-tutor-rates/list',
  async () => {
    const path = `${ApiPaths.oneToOneTutorRates}`;

    const response = await apiDataProvider.get<
      TApiResponse<IOneToOneTutorRate[]>
    >(path);

    return response.data;
  }
);

export const getTutorRatesForAStudent = createAsyncThunk(
  '/user/one-to-one-tutor-rates/student/:id',
  async (data: TGetTutorRatesForAStudent) => {
    let path = `${ApiPaths.oneToOneTutorRates}/student/${
      data.studentId
    }?tutorId=${data.tutorId}&curriculum=${encodeURIComponent(
      data.curriculum
    )}&grade=${encodeURIComponent(data.grade)}&studentId=${data.studentId}${
      data.courseId ? `&courseId=${data.courseId}` : ''
    }`;

    if (data.includeResourceResourceFee) {
      path += `&includeResourceResourceFee=1`;
    }

    const response = await apiDataProvider.get<
      TApiResponse<{
        amount: number;
        currency: string;
        yearlyPremiumAccessFee?: number;
      }>
    >(path);

    return response.data;
  }
);
